// const relCm = {
//     attributeKey: "rel_cm",
//     attributeValues: {
//         "A": {
//             size: 10
//         },
//         "B": {
//             size: 7
//         },
//         "C": {
//             size: 5
//         },
//         "D": {
//             size: 3
//         }
//     }
// };
//
// const relCmSmallMap = {
//     attributeKey: "rel_cm",
//     attributeValues: {
//         "A": {
//             size: 4
//         },
//         "B": {
//             size: 3
//         },
//         "C": {
//             size: 2
//         },
//         "D": {
//             size: 1
//         }
//     }
// };

// ==== FRAGMENTS ===

/* Base */
const zoneBase = {
	fill: '#cccccc',
	fillOpacity: 0.7,
	outlineColor: '#777777',
	outlineWidth: 1,
	outlineOpacity: 1,
};

const zoneBaseSmall = {
	...zoneBase,
	outlineOpacity: 0.3,
};

const zoneBaseTransparent = {
	...zoneBase,
	fill: null,
	outlineWidth: 1,
	fillOpacity: 0,
	outlineColor: '#222222',
};

const zoneBaseTransparentSmall = {
	...zoneBaseTransparent,
	outlineWidth: 0,
};

const zoneBaseInvisible = {
	...zoneBase,
	fill: null,
	outlineWidth: 0,
	fillOpacity: 0.7,
};

const roadBase = {
	outlineColor: '#555555',
	outlineWidth: 6,
	outlineOpacity: 1,
};

const roadBaseSmall = {
	...roadBase,
	outlineWidth: 2,
};

const interferometryBase = {
	fill: '#cccccc',
	fillOpacity: 1,
	outlineColor: '#555555',
	outlineWidth: 1,
	outlineOpacity: 1,
	size: 10,
};

const interferometryBaseAsPoints = {
	...interferometryBase,
	size: 20,
	outlineWidth: 0,
};

const interferometryBaseSmall = {
	...interferometryBase,
	outlineWidth: 0,
	size: 2,
};

/* Attributes */
const p75AttributeIntervals = {
	attributeKey: 'defo_p75',
	attributeClasses: [
		{
			interval: [-1000, -50],
			name: '< -50',
			fill: '#b1001d',
		},
		{
			interval: [-50, -40],
			fill: '#ca2d2f',
		},
		{
			interval: [-40, -30],
			fill: '#e25b40',
		},
		{
			interval: [-30, -20],
			fill: '#f6963f',
		},
		{
			interval: [-20, -10],
			fill: '#ffee01',
		},
		{
			interval: [-10, 0],
			fill: '#c1ff3f',
		},
		{
			interval: [0, 10],
			fill: '#50d70d',
		},
		{
			interval: [10, 20],
			fill: '#50d4c5',
		},
		{
			interval: [20, 30],
			fill: '#76d0e1',
		},
		{
			interval: [30, 40],
			fill: '#77a1db',
		},
		{
			interval: [40, 50],
			fill: '#5370d7',
		},
		{
			interval: [50, 1000],
			name: '> 50',
			fill: '#2f3fd2',
		},
	],
};

// Obsolete style for chng_year

// const chngYearAttributeValues = {
//     attributeKey: "chng_year",
//     attributeValues: {
//         "2000-2009": {
//             fill: "#feebe2"
//         },
// 		"2010-2013": {
// 			fill: "#ffa3a8"
// 		},
// 		"2014-2016": {
// 			fill: "#e34998"
// 		},
// 		"2017-2019": {
// 			fill: "#b61586"
// 		}
//     }
// };

const chngYearAttributeValues = {
	attributeKey: 'chng_year_',
	attributeValues: {
		'1986-1990': {
			fill: '#f58700',
		},
		'1991-1995': {
			fill: '#e7ed00',
		},
		'1996-2000': {
			fill: '#22cc00',
		},
		'2001-2005': {
			fill: '#00aab0',
		},
		'2006-2010': {
			fill: '#0072c9',
		},
		'2011-2015': {
			fill: '#4828bd',
		},
		'2016-2020': {
			fill: '#7e008f',
		},
	},
};

const chngTypeAttributeValues = {
	attributeKey: 'chng_type',
	attributeValues: {
		'Densif./Rebuild.': {
			name: 'Rebuilding in the last decade',
			fill: '#ffa79b',
		},
		Sprawl: {
			name: 'Expansion in the last decade',
			fill: '#ff2b2e',
		},
	},
};

const chngTypeLandUseAttributeValues = {
	attributeKey: 'ua_l3',
	attributeValues: {
		13300: {
			name: 'Construction area (current)',
			fill: '#ff50e5',
		},
	},
};

const landUseClassification = {
	attributeKey: 'ua_l3',
	attributeValues: {
		12100: {
			name:
				'Urban Fabric: Non-residential (Public, Military and Private Units) & Mixed',
			fill: '#730000',
		},
		11100: {
			name: 'Urban fabric: Residential - High Density Continuous',
			fill: '#ff0000',
		},
		11200: {
			name: 'Urban Fabric: Residential - Discontinuous',
			fill: '#ff6666',
		},
		12000: {
			name: 'Industrial & Commercial Units',
			fill: '#c500ff',
		},
		12200: {
			name: 'Arterial roads',
			fill: '#4e4e4e',
		},
		13300: {
			name: 'Construction Sites',
			fill: '#ff66de',
		},
		13400: {
			name: 'Land Without Current Use',
			fill: '#d7d7d7',
		},
		14100: {
			name: 'Green Urban Areas',
			fill: '#55ff00',
		},
		14200: {
			name: 'Sports and Leisure Facilities',
			fill: '#ffaa00',
		},
		20000: {
			name: 'Agricultural Area',
			fill: '#ffebaf',
		},
		30000: {
			name: 'Natural areas (Grasslands, Forest, Bare soil)',
			fill: '#91522d',
		},
		40000: {
			name: 'Natural & Semi-natural Tree Stands',
			fill: '#167d08',
		},
		50000: {
			name: 'Inland Water',
			fill: '#0070ff',
		},
	},
};

const velAvg = {
	attributeKey: 'vel_avg',
	attributeClasses: [
		{
			fill: '#b1001d',
			name: '< -50',
			interval: [-1000, -50],
			intervalBounds: [false, true],
		},
		{
			fill: '#ca2d2f',
			interval: [-50, -40],
			intervalBounds: [false, true],
		},
		{
			fill: '#e25b40',
			interval: [-40, -30],
			intervalBounds: [false, true],
		},
		{
			fill: '#ffaa00',
			interval: [-30, -20],
			intervalBounds: [false, true],
		},
		{
			fill: '#ffff00',
			interval: [-20, -10],
			intervalBounds: [false, true],
		},
		{
			fill: '#a0f000',
			interval: [-10, 0],
			intervalBounds: [false, true],
		},
		{
			fill: '#4ce600',
			interval: [0, 10],
			intervalBounds: [false, true],
		},
		{
			fill: '#50d48e',
			interval: [10, 20],
			intervalBounds: [false, true],
		},
		{
			fill: '#00c3ff',
			interval: [20, 30],
			intervalBounds: [false, true],
		},
		{
			fill: '#0f80d1',
			interval: [30, 40],
			intervalBounds: [false, true],
		},
		{
			fill: '#004ca8',
			interval: [40, 50],
			intervalBounds: [false, true],
		},
		{
			fill: '#003e8a',
			name: '> 50',
			interval: [50, 1000],
			intervalBounds: [false, false],
		},
	],
};

const velAvgRoads = {
	attributeKey: 'vel_avg',
	attributeClasses: [
		{
			interval: [-1000, -50],
			name: '< -50',
			outlineColor: '#b1001d',
			intervalBounds: [false, true],
		},
		{
			interval: [-50, -40],
			outlineColor: '#c8292d',
			intervalBounds: [false, true],
		},
		{
			interval: [-40, -30],
			outlineColor: '#de533d',
			intervalBounds: [false, true],
		},
		{
			interval: [-30, -20],
			outlineColor: '#f47d4e',
			intervalBounds: [false, true],
		},
		{
			interval: [-20, -10],
			intervalBounds: [false, true],
			outlineColor: '#f9d817',
		},
		{
			interval: [-10, 0],
			outlineColor: '#a0f000',
			intervalBounds: [false, true],
		},
		{
			interval: [0, 10],
			intervalBounds: [false, true],
			outlineColor: '#50d70d',
		},
		{
			interval: [10, 20],
			intervalBounds: [false, true],
			outlineColor: '#92c5de',
		},
		{
			interval: [20, 1000],
			intervalBounds: [false, false],
			name: '> 20',
			outlineColor: '#7198da',
		},
	],
};

const roadTypology = {
	attributeKey: 'rd_clas_in',
	attributeClasses: [
		{
			name: 'Arteriar road',
			outlineWidth: 6,
			outlineColor: '#222222',
			interval: [4, 5],
			intervalBounds: [true, true],
		},
		{
			name: 'Collector road',
			outlineWidth: 3,
			outlineColor: '#222222',
			interval: [0, 3],
			intervalBounds: [true, true],
		},
	],
};

const roadTypologySmall = {
	outlineWidth: 2,
	outlineColor: '#222222',
};

const spatialPatternType = {
	attributeKey: 'lmi_potype',
	attributeValues: {
		LL: {
			name: 'LL - Cluster: subsiding points',
			fill: '#ffcc8d',
		},
		HH: {
			name: 'HH - Cluster: stable points',
			fill: '#bdffab',
		},
		LH: {
			name: 'LH - Outlier: subsiding point',
			fill: '#ff0101',
		},
		HL: {
			name: 'HL - Outlier: stable  point',
			fill: '#324ad9',
		},
	},
};

const alarms = {
	attributeKey: 'cl_warn',
	attributeValues: {
		10: {
			outlineWidth: 2,
			outlineColor: '#ff0000',
		},
		12: {
			outlineWidth: 2,
			outlineColor: '#ff0000',
		},
		22: {
			outlineWidth: 2,
			outlineColor: '#ff0000',
		},
		500: {
			outlineWidth: 2,
			outlineColor: '#ff0000',
		},
		11: {
			outlineWidth: 2,
			outlineColor: '#ff0000',
		},
		20: {
			outlineWidth: 2,
			outlineColor: '#ff0000',
		},
	},
};

// ==== COMPLETE STYLES ===
const riskAssessmentZonesDeformationBig = {
	key: 'riskAssessmentZonesDeformationBig',
	data: {
		nameDisplay: 'Exposure',
		description: 'p75',
		definition: {
			rules: [
				{
					styles: [zoneBase, p75AttributeIntervals],
				},
			],
		},
	},
};

const riskAssessmentZonesDeformationSmall = {
	key: 'riskAssessmentZonesDeformationSmall',
	data: {
		nameDisplay: 'Exposure',
		description: '',
		definition: {
			rules: [
				{
					styles: [zoneBaseSmall, p75AttributeIntervals],
				},
			],
		},
	},
};

const riskAssessmentZonesChangeYearBig = {
	key: 'riskAssessmentZonesChangeYearBig',
	data: {
		nameDisplay: 'Chronology of built-up expansion',
		description: '',
		definition: {
			rules: [
				{
					styles: [zoneBaseInvisible, chngYearAttributeValues],
				},
			],
		},
	},
};

const riskAssessmentZonesLandUseBig = {
	key: 'riskAssessmentZonesLandUseBig',
	data: {
		nameDisplay: 'Typology',
		description: '',
		definition: {
			rules: [
				{
					styles: [zoneBase, landUseClassification],
				},
			],
		},
	},
};

const riskAssessmentZonesLandUseSmall = {
	key: 'riskAssessmentZonesLandUseSmall',
	data: {
		nameDisplay: 'Typology',
		description: '',
		definition: {
			rules: [
				{
					styles: [zoneBase, landUseClassification],
				},
			],
		},
	},
};

const riskAssessmentZonesChangeYearSmall = {
	key: 'riskAssessmentZonesChangeYearSmall',
	data: {
		nameDisplay: 'Chronology of built-up extension',
		description: '',
		definition: {
			rules: [
				{
					styles: [zoneBaseInvisible, chngYearAttributeValues],
				},
			],
		},
	},
};

const riskAssessmentZonesChangeTypeBig = {
	key: 'riskAssessmentZonesChangeTypeBig',
	data: {
		nameDisplay: 'Built-up changes',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						zoneBase,
						chngTypeAttributeValues,
						chngTypeLandUseAttributeValues,
					],
				},
			],
		},
	},
};

const riskAssessmentZonesChangeTypeSmall = {
	key: 'riskAssessmentZonesChangeTypeSmall',
	data: {
		nameDisplay: 'Built-up changes',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						zoneBaseSmall,
						chngTypeAttributeValues,
						chngTypeLandUseAttributeValues,
					],
				},
			],
		},
	},
};

const riskAssessmentRoadsVelAvgBig = {
	key: 'riskAssessmentRoadsVelAvgBig',
	data: {
		nameDisplay: 'Exposure',
		description: '',
		definition: {
			rules: [
				{
					styles: [roadBase, velAvgRoads],
				},
			],
		},
	},
};

const riskAssessmentRoadsVelAvgSmall = {
	key: 'riskAssessmentRoadsVelAvgSmall',
	data: {
		nameDisplay: 'Exposure',
		description: '',
		definition: {
			rules: [
				{
					styles: [roadBaseSmall, velAvgRoads],
				},
			],
		},
	},
};

const riskAssessmentRoadsTypologyBig = {
	key: 'riskAssessmentRoadsTypologyBig',
	data: {
		nameDisplay: 'Typology',
		description: '',
		definition: {
			rules: [
				{
					styles: [roadBase, roadTypology],
				},
			],
		},
	},
};

const riskAssessmentRoadsTypologySmall = {
	key: 'riskAssessmentRoadsTypologySmall',
	data: {
		nameDisplay: 'Typology',
		description: '',
		definition: {
			rules: [
				{
					styles: [roadBaseSmall, roadTypologySmall],
				},
			],
		},
	},
};

const interferometryPointsVelAvgBig = {
	key: 'interferometryPointsVelAvgBig',
	data: {
		nameDisplay: 'Displacement',
		description: '',
		definition: {
			rules: [
				{
					styles: [interferometryBase, velAvg],
				},
			],
		},
	},
};

const interferometryPointsVelAvgBigAsPoints = {
	key: 'interferometryPointsVelAvgBigAsPoints',
	data: {
		nameDisplay: 'Displacement',
		description: '',
		definition: {
			rules: [
				{
					styles: [interferometryBaseAsPoints, velAvg],
				},
			],
		},
	},
};

const interferometryPointsVelAvgSmall = {
	key: 'interferometryPointsVelAvgSmall',
	data: {
		nameDisplay: 'Displacement',
		description: '',
		definition: {
			rules: [
				{
					styles: [interferometryBaseSmall, velAvg],
				},
			],
		},
	},
};

const interferometryPointsVelAvgAlarmBig = {
	key: 'interferometryPointsVelAvgAlarmBig',
	data: {
		nameDisplay: 'Displacement & alarm',
		description: '',
		definition: {
			rules: [
				{
					styles: [interferometryBase, velAvg, alarms],
				},
			],
		},
	},
};

const interferometryPointsVelAvgAlarmBigAsPoints = {
	key: 'interferometryPointsVelAvgAlarmBigAsPoints',
	data: {
		nameDisplay: 'Displacement & alarm',
		description: '',
		definition: {
			rules: [
				{
					styles: [interferometryBaseAsPoints, velAvg, alarms],
				},
			],
		},
	},
};

const interferometryPointsVelAvgAlarmSmall = {
	key: 'interferometryPointsVelAvgAlarmSmall',
	data: {
		nameDisplay: 'Displacement & alarm',
		description: '',
		definition: {
			rules: [
				{
					styles: [interferometryBaseSmall, velAvg, alarms],
				},
			],
		},
	},
};

const interferometryPointsSpatialPatternTypeBig = {
	key: 'interferometryPointsSpatialPatternTypeBig',
	data: {
		nameDisplay: 'Spatial patterns',
		description: '',
		definition: {
			rules: [
				{
					styles: [interferometryBase, spatialPatternType],
				},
			],
		},
	},
};

const interferometryPointsSpatialPatternTypeBigAsPoints = {
	key: 'interferometryPointsSpatialPatternTypeBigAsPoints',
	data: {
		nameDisplay: 'Spatial patterns',
		description: '',
		definition: {
			rules: [
				{
					styles: [interferometryBaseAsPoints, spatialPatternType],
				},
			],
		},
	},
};

const interferometryPointsSpatialPatternTypeSmall = {
	key: 'interferometryPointsSpatialPatternTypeSmall',
	data: {
		nameDisplay: 'Spatial patterns',
		description: '',
		definition: {
			rules: [
				{
					styles: [interferometryBaseSmall, spatialPatternType],
				},
			],
		},
	},
};

const interferometryZonesBig = {
	key: 'interferometryZonesBig',
	data: {
		nameDisplay: 'Zones',
		description: '',
		definition: {
			rules: [
				{
					styles: [zoneBaseTransparent],
				},
			],
		},
	},
};

const interferometryZonesSmall = {
	key: 'interferometryZonesSmall',
	data: {
		nameDisplay: 'Zones',
		description: '',
		definition: {
			rules: [
				{
					styles: [zoneBaseTransparentSmall],
				},
			],
		},
	},
};

export default {
	// fragments
	zoneBase,
	roadBase,
	interferometryBase,

	p75AttributeIntervals,
	chngYearAttributeValues,
	chngTypeAttributeValues,
	chngTypeLandUseAttributeValues,
	landUseClassification,

	spatialPatternType,
	velAvg,
	alarms,

	velAvgRoads,
	roadTypology,

	// complete styles
	byKey: {
		riskAssessmentZonesDeformationBig,
		riskAssessmentZonesDeformationSmall,

		riskAssessmentZonesLandUseBig,
		riskAssessmentZonesLandUseSmall,

		riskAssessmentZonesChangeYearBig,
		riskAssessmentZonesChangeYearSmall,

		riskAssessmentZonesChangeTypeBig,
		riskAssessmentZonesChangeTypeSmall,

		riskAssessmentRoadsVelAvgBig,
		riskAssessmentRoadsVelAvgSmall,

		riskAssessmentRoadsTypologyBig,
		riskAssessmentRoadsTypologySmall,

		interferometryPointsVelAvgBig,
		interferometryPointsVelAvgBigAsPoints,
		interferometryPointsVelAvgSmall,

		interferometryPointsVelAvgAlarmBig,
		interferometryPointsVelAvgAlarmBigAsPoints,
		interferometryPointsVelAvgAlarmSmall,

		interferometryPointsSpatialPatternTypeBig,
		interferometryPointsSpatialPatternTypeBigAsPoints,
		interferometryPointsSpatialPatternTypeSmall,

		interferometryZonesBig,
		interferometryZonesSmall,
	},
};
